var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.83334H3.22007L6.4734 1.58001C6.7334 1.32001 6.7334 0.893339 6.4734 0.633339C6.2134 0.373339 5.7934 0.373339 5.5334 0.633339L1.14007 5.02667C0.880068 5.28667 0.880068 5.70667 1.14007 5.96667L5.5334 10.36C5.7934 10.62 6.2134 10.62 6.4734 10.36C6.7334 10.1 6.7334 9.68001 6.4734 9.42001L3.22007 6.16667H10.6667C11.0334 6.16667 11.3334 5.86667 11.3334 5.50001C11.3334 5.13334 11.0334 4.83334 10.6667 4.83334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIcon);
export default __webpack_public_path__ + "static/media/GoBackIcon.e00c7d5482fe7bec5aec55dd83ad500b.svg";
export { ForwardRef as ReactComponent };